import {
  fastingPlan1Image,
  fastingPlan2Image,
  fastingPlan3Image,
  fastingPlan4Image,
  fastingPlan5Image,
} from '@src/assets/images';
import { IFastingStartTimeMap } from '@src/interfaces/fasting.interfaces';

export const MEAL_TYPE = {
  BREAKFAST: 'BREAKFAST',
  LUNCH: 'LUNCH',
  DINNER: 'DINNER',
} as const;

// INFO: 4 - is default
export const FASTING_START_TIME_MAP: IFastingStartTimeMap = {
  [MEAL_TYPE.BREAKFAST]: {
    1: '08:00',
    2: '10:00',
    3: '12:00',
    4: undefined,
  },
  [MEAL_TYPE.LUNCH]: {
    1: '12:00',
    2: '14:00',
    3: '16:00',
    4: undefined,
  },
  [MEAL_TYPE.DINNER]: {
    1: '18:00',
    2: '20:00',
    3: '22:00',
    4: undefined,
  },
};

export const FASTING_PLANS_SLIDES: {
  id: number;
  title: string;
  description: string;
  image: string;
}[] = [
  fastingPlan1Image,
  fastingPlan2Image,
  fastingPlan3Image,
  fastingPlan4Image,
  fastingPlan5Image,
].map((image, i) => ({
  id: i + 1,
  title: `fastingPlans.slides.${i + 1}.title`,
  description: `fastingPlans.slides.${i + 1}.description`,
  image,
}));
